import { VariationOption } from '../models';

export interface VariationCatalogOption {
  id: number;
  code: string;
  label: string;
}

export interface VariationTypeGroup {
  id: number;
  name: string;
  options: VariationCatalogOption[];
}

export function groupVariationOptions(options: VariationOption[]): VariationTypeGroup[] {
  const byType = new Map<number, VariationTypeGroup>();

  for (const option of options) {
    if (!byType.has(option.variationTypeId)) {
      byType.set(option.variationTypeId, {
        id: option.variationTypeId,
        name: option.variationTypeName,
        options: [],
      });
    }
    byType.get(option.variationTypeId)!.options.push({
      id: option.id,
      code: option.code,
      label: option.label,
    });
  }

  const groups = Array.from(byType.values()).sort((a, b) => a.id - b.id);
  const optionOrder = new Map(options.map((o) => [o.id, o.displayOrder]));

  for (const group of groups) {
    group.options.sort((a, b) => (optionOrder.get(a.id) ?? 0) - (optionOrder.get(b.id) ?? 0));
  }

  return groups;
}
